import DASHBOARD_ROUTES from '@/presentation/modules/dashboard/constants/routes/index';

const dashboardRoutes = [
	{
		name: DASHBOARD_ROUTES.root.name,
		path: DASHBOARD_ROUTES.root.path,
		redirect: DASHBOARD_ROUTES.root.redirect,
		meta: DASHBOARD_ROUTES.root.meta,
		component: DASHBOARD_ROUTES.root.component,
		children: [
			{
				name: DASHBOARD_ROUTES.indexDashboard.name,
				path: DASHBOARD_ROUTES.indexDashboard.path,
				component: DASHBOARD_ROUTES.indexDashboard.component,
			},
			{
				name: DASHBOARD_ROUTES.businessGuide.name,
				path: DASHBOARD_ROUTES.businessGuide.path,
				meta: DASHBOARD_ROUTES.businessGuide.meta,
				component: DASHBOARD_ROUTES.businessGuide.component,
			},
			{
				name: DASHBOARD_ROUTES.financialDashboard.name,
				path: DASHBOARD_ROUTES.financialDashboard.path,
				meta: DASHBOARD_ROUTES.financialDashboard.meta,
				component: DASHBOARD_ROUTES.financialDashboard.component,
			},
			{
				name: DASHBOARD_ROUTES.businessOnboarding.name,
				path: DASHBOARD_ROUTES.businessOnboarding.path,
				meta: DASHBOARD_ROUTES.businessOnboarding.meta,
				component: DASHBOARD_ROUTES.businessOnboarding.component,
			},
			{
				name: DASHBOARD_ROUTES.wallet.name,
				path: DASHBOARD_ROUTES.wallet.path,
				meta: DASHBOARD_ROUTES.wallet.meta,
				component: DASHBOARD_ROUTES.wallet.component,
			},
			{
				name: DASHBOARD_ROUTES.withdraw.name,
				path: DASHBOARD_ROUTES.withdraw.path,
				meta: DASHBOARD_ROUTES.withdraw.meta,
				redirect: {
					path: '/dashboard/wallet',
					query: { mode: 'withdraw' },
				},
			},
			{
				name: DASHBOARD_ROUTES.settingRoot.name,
				path: DASHBOARD_ROUTES.settingRoot.path,
				meta: DASHBOARD_ROUTES.settingRoot.meta,
				component: DASHBOARD_ROUTES.settingRoot.component,
				children: [
					{
						name: DASHBOARD_ROUTES.setting.name,
						path: DASHBOARD_ROUTES.setting.path,
						component: DASHBOARD_ROUTES.setting.component,
					},
					{
						name: DASHBOARD_ROUTES.identityInformation.name,
						path: DASHBOARD_ROUTES.identityInformation.path,
						meta: DASHBOARD_ROUTES.identityInformation.meta,
						component: DASHBOARD_ROUTES.identityInformation.component,
					},
					{
						name: DASHBOARD_ROUTES.messageManager.name,
						path: DASHBOARD_ROUTES.messageManager.path,
						meta: DASHBOARD_ROUTES.messageManager.meta,
						component: DASHBOARD_ROUTES.messageManager.component,
					},
					{
						name: DASHBOARD_ROUTES.category.name,
						path: DASHBOARD_ROUTES.category.path,
						meta: DASHBOARD_ROUTES.category.meta,
						component: DASHBOARD_ROUTES.category.component,
					},
					{
						name: DASHBOARD_ROUTES.artists.name,
						path: DASHBOARD_ROUTES.artists.path,
						meta: DASHBOARD_ROUTES.artists.meta,
						component: DASHBOARD_ROUTES.artists.component,
						children: [],
					},
					{
						name: DASHBOARD_ROUTES.updateArtists.name,
						path: DASHBOARD_ROUTES.updateArtists.path,
						meta: DASHBOARD_ROUTES.updateArtists.meta,
						component: DASHBOARD_ROUTES.updateArtists.component,
					},
					{
						name: DASHBOARD_ROUTES.createArtists.name,
						path: DASHBOARD_ROUTES.createArtists.path,
						meta: DASHBOARD_ROUTES.createArtists.meta,
						component: DASHBOARD_ROUTES.createArtists.component,
					},
					{
						name: DASHBOARD_ROUTES.services.name,
						path: DASHBOARD_ROUTES.services.path,
						meta: DASHBOARD_ROUTES.services.meta,
						component: DASHBOARD_ROUTES.services.component,
					},
					{
						name: DASHBOARD_ROUTES.serviceArtistAssignments.name,
						path: DASHBOARD_ROUTES.serviceArtistAssignments.path,
						meta: DASHBOARD_ROUTES.serviceArtistAssignments.meta,
						component: DASHBOARD_ROUTES.serviceArtistAssignments.component,
					},
					{
						name: DASHBOARD_ROUTES.sendSms.name,
						path: DASHBOARD_ROUTES.sendSms.path,
						meta: DASHBOARD_ROUTES.sendSms.meta,
						component: DASHBOARD_ROUTES.sendSms.component,
					},
					{
						name: DASHBOARD_ROUTES.businessSetupSteps.name,
						path: DASHBOARD_ROUTES.businessSetupSteps.path,
						meta: DASHBOARD_ROUTES.businessSetupSteps.meta,
						component: DASHBOARD_ROUTES.businessSetupSteps.component,
					},
				],
			},
			{
				name: DASHBOARD_ROUTES.requestRoot.name,
				path: DASHBOARD_ROUTES.requestRoot.path,
				component: DASHBOARD_ROUTES.requestRoot.component,
				meta: DASHBOARD_ROUTES.requestRoot.meta,
				children: [
					{
						name: DASHBOARD_ROUTES.request.name,
						path: DASHBOARD_ROUTES.request.path,
						component: DASHBOARD_ROUTES.request.component,
					},
					{
						name: DASHBOARD_ROUTES.receiveRequests.name,
						path: DASHBOARD_ROUTES.receiveRequests.path,
						meta: DASHBOARD_ROUTES.receiveRequests.meta,
						component: DASHBOARD_ROUTES.receiveRequests.component,
					},
					{
						name: DASHBOARD_ROUTES.sendRequests.name,
						path: DASHBOARD_ROUTES.sendRequests.path,
						meta: DASHBOARD_ROUTES.sendRequests.meta,
						component: DASHBOARD_ROUTES.sendRequests.component,
					},
					{
						name: DASHBOARD_ROUTES.bookAppointment.name,
						path: DASHBOARD_ROUTES.bookAppointment.path,
						meta: DASHBOARD_ROUTES.bookAppointment.meta,
						component: DASHBOARD_ROUTES.bookAppointment.component,
					},
				],
			},
			{
				name: DASHBOARD_ROUTES.adminRoot.name,
				path: DASHBOARD_ROUTES.adminRoot.path,
				meta: DASHBOARD_ROUTES.adminRoot.meta,
				component: DASHBOARD_ROUTES.adminRoot.component,
				children: [
					{
						name: DASHBOARD_ROUTES.adminIndex.name,
						path: DASHBOARD_ROUTES.adminIndex.path,
						meta: DASHBOARD_ROUTES.adminIndex.meta,
						component: DASHBOARD_ROUTES.adminIndex.component,
					},
					{
						name: DASHBOARD_ROUTES.adminBusiness.name,
						path: DASHBOARD_ROUTES.adminBusiness.path,
						meta: DASHBOARD_ROUTES.adminBusiness.meta,
						component: DASHBOARD_ROUTES.adminBusiness.component,
					},
					{
						name: DASHBOARD_ROUTES.adminBusinessDetail.name,
						path: DASHBOARD_ROUTES.adminBusinessDetail.path,
						meta: DASHBOARD_ROUTES.adminBusinessDetail.meta,
						props: DASHBOARD_ROUTES.adminBusinessDetail.props,
						component: DASHBOARD_ROUTES.adminBusinessDetail.component,
					},
					{
						name: DASHBOARD_ROUTES.adminBusinessEdit.name,
						path: DASHBOARD_ROUTES.adminBusinessEdit.path,
						meta: DASHBOARD_ROUTES.adminBusinessEdit.meta,
						component: DASHBOARD_ROUTES.adminBusinessEdit.component,
					},
					{
						name: DASHBOARD_ROUTES.adminSmsPlan.name,
						path: DASHBOARD_ROUTES.adminSmsPlan.path,
						meta: DASHBOARD_ROUTES.adminSmsPlan.meta,
						component: DASHBOARD_ROUTES.adminSmsPlan.component,
					},
					{
						name: DASHBOARD_ROUTES.adminSystemSmsTemplates.name,
						path: DASHBOARD_ROUTES.adminSystemSmsTemplates.path,
						meta: DASHBOARD_ROUTES.adminSystemSmsTemplates.meta,
						component: DASHBOARD_ROUTES.adminSystemSmsTemplates.component,
					},
					{
						name: DASHBOARD_ROUTES.adminCategories.name,
						path: DASHBOARD_ROUTES.adminCategories.path,
						meta: DASHBOARD_ROUTES.adminCategories.meta,
						component: DASHBOARD_ROUTES.adminCategories.component,
					},
					{
						name: DASHBOARD_ROUTES.adminTransferFee.name,
						path: DASHBOARD_ROUTES.adminTransferFee.path,
						meta: DASHBOARD_ROUTES.adminTransferFee.meta,
						component: DASHBOARD_ROUTES.adminTransferFee.component,
					},
					{
						name: DASHBOARD_ROUTES.adminSubscriptionPlans.name,
						path: DASHBOARD_ROUTES.adminSubscriptionPlans.path,
						meta: DASHBOARD_ROUTES.adminSubscriptionPlans.meta,
						component: DASHBOARD_ROUTES.adminSubscriptionPlans.component,
					},
					{
						name: DASHBOARD_ROUTES.adminDisputes.name,
						path: DASHBOARD_ROUTES.adminDisputes.path,
						meta: DASHBOARD_ROUTES.adminDisputes.meta,
						component: DASHBOARD_ROUTES.adminDisputes.component,
					},
					{
						name: DASHBOARD_ROUTES.adminWithdraw.name,
						path: DASHBOARD_ROUTES.adminWithdraw.path,
						meta: DASHBOARD_ROUTES.adminWithdraw.meta,
						component: DASHBOARD_ROUTES.adminWithdraw.component,
					},
					{
						name: DASHBOARD_ROUTES.adminCreditSms.name,
						path: DASHBOARD_ROUTES.adminCreditSms.path,
						meta: DASHBOARD_ROUTES.adminCreditSms.meta,
						component: DASHBOARD_ROUTES.adminCreditSms.component,
					},
					{
						name: DASHBOARD_ROUTES.adminPushNotifications.name,
						path: DASHBOARD_ROUTES.adminPushNotifications.path,
						meta: DASHBOARD_ROUTES.adminPushNotifications.meta,
						component: DASHBOARD_ROUTES.adminPushNotifications.component,
					},
					{
						name: DASHBOARD_ROUTES.adminSecurity.name,
						path: DASHBOARD_ROUTES.adminSecurity.path,
						meta: DASHBOARD_ROUTES.adminSecurity.meta,
						component: DASHBOARD_ROUTES.adminSecurity.component,
					},
					{
						name: DASHBOARD_ROUTES.adminMarketingCampaigns.name,
						path: DASHBOARD_ROUTES.adminMarketingCampaigns.path,
						meta: DASHBOARD_ROUTES.adminMarketingCampaigns.meta,
						component: DASHBOARD_ROUTES.adminMarketingCampaigns.component,
					},
					{
						name: DASHBOARD_ROUTES.adminPartners.name,
						path: DASHBOARD_ROUTES.adminPartners.path,
						meta: DASHBOARD_ROUTES.adminPartners.meta,
						component: DASHBOARD_ROUTES.adminPartners.component,
					},
					{
						name: DASHBOARD_ROUTES.adminGrowthCenter.name,
						path: DASHBOARD_ROUTES.adminGrowthCenter.path,
						meta: DASHBOARD_ROUTES.adminGrowthCenter.meta,
						component: DASHBOARD_ROUTES.adminGrowthCenter.component,
					},
					{
						name: DASHBOARD_ROUTES.adminGrowthCenterAcquisition.name,
						path: DASHBOARD_ROUTES.adminGrowthCenterAcquisition.path,
						meta: DASHBOARD_ROUTES.adminGrowthCenterAcquisition.meta,
						component: DASHBOARD_ROUTES.adminGrowthCenterAcquisition.component,
					},
					{
						name: DASHBOARD_ROUTES.adminGrowthCenterMarketplaceHealth.name,
						path: DASHBOARD_ROUTES.adminGrowthCenterMarketplaceHealth.path,
						meta: DASHBOARD_ROUTES.adminGrowthCenterMarketplaceHealth.meta,
						component: DASHBOARD_ROUTES.adminGrowthCenterMarketplaceHealth.component,
					},
					{
						name: DASHBOARD_ROUTES.adminGrowthCenterRevenue.name,
						path: DASHBOARD_ROUTES.adminGrowthCenterRevenue.path,
						meta: DASHBOARD_ROUTES.adminGrowthCenterRevenue.meta,
						component: DASHBOARD_ROUTES.adminGrowthCenterRevenue.component,
					},
					{
						name: DASHBOARD_ROUTES.adminGrowthCenterCampaigns.name,
						path: DASHBOARD_ROUTES.adminGrowthCenterCampaigns.path,
						meta: DASHBOARD_ROUTES.adminGrowthCenterCampaigns.meta,
						component: DASHBOARD_ROUTES.adminGrowthCenterCampaigns.component,
					},
					{
						name: DASHBOARD_ROUTES.adminGrowthCenterCampaignDetails.name,
						path: DASHBOARD_ROUTES.adminGrowthCenterCampaignDetails.path,
						meta: DASHBOARD_ROUTES.adminGrowthCenterCampaignDetails.meta,
						component: DASHBOARD_ROUTES.adminGrowthCenterCampaignDetails.component,
					},
					{
						name: DASHBOARD_ROUTES.adminGrowthCenterEventRules.name,
						path: DASHBOARD_ROUTES.adminGrowthCenterEventRules.path,
						meta: DASHBOARD_ROUTES.adminGrowthCenterEventRules.meta,
						component: DASHBOARD_ROUTES.adminGrowthCenterEventRules.component,
					},
					{
						name: DASHBOARD_ROUTES.adminGrowthCenterSms.name,
						path: DASHBOARD_ROUTES.adminGrowthCenterSms.path,
						meta: DASHBOARD_ROUTES.adminGrowthCenterSms.meta,
						component: DASHBOARD_ROUTES.adminGrowthCenterSms.component,
					},
					{
						name: DASHBOARD_ROUTES.adminGrowthCenterCustomers.name,
						path: DASHBOARD_ROUTES.adminGrowthCenterCustomers.path,
						meta: DASHBOARD_ROUTES.adminGrowthCenterCustomers.meta,
						component: DASHBOARD_ROUTES.adminGrowthCenterCustomers.component,
					},
					{
						name: DASHBOARD_ROUTES.adminGrowthCenterCohorts.name,
						path: DASHBOARD_ROUTES.adminGrowthCenterCohorts.path,
						meta: DASHBOARD_ROUTES.adminGrowthCenterCohorts.meta,
						component: DASHBOARD_ROUTES.adminGrowthCenterCohorts.component,
					},
					{
						name: DASHBOARD_ROUTES.adminGrowthCenterInsights.name,
						path: DASHBOARD_ROUTES.adminGrowthCenterInsights.path,
						meta: DASHBOARD_ROUTES.adminGrowthCenterInsights.meta,
						component: DASHBOARD_ROUTES.adminGrowthCenterInsights.component,
					},
				],
			},
			{
				name: DASHBOARD_ROUTES.partnerDashboard.name,
				path: DASHBOARD_ROUTES.partnerDashboard.path,
				meta: DASHBOARD_ROUTES.partnerDashboard.meta,
				component: DASHBOARD_ROUTES.partnerDashboard.component,
			},
			{
				name: DASHBOARD_ROUTES.creditCharge.name,
				path: DASHBOARD_ROUTES.creditCharge.path,
				meta: DASHBOARD_ROUTES.creditCharge.meta,
				component: DASHBOARD_ROUTES.creditCharge.component,
			},
			{
				name: DASHBOARD_ROUTES.customers.name,
				path: DASHBOARD_ROUTES.customers.path,
				meta: DASHBOARD_ROUTES.customers.meta,
				component: DASHBOARD_ROUTES.customers.component,
			},
			{
				name: DASHBOARD_ROUTES.customerClub.name,
				path: DASHBOARD_ROUTES.customerClub.path,
				meta: DASHBOARD_ROUTES.customerClub.meta,
				component: DASHBOARD_ROUTES.customerClub.component,
			},
			{
				name: DASHBOARD_ROUTES.specialOffers.name,
				path: DASHBOARD_ROUTES.specialOffers.path,
				meta: DASHBOARD_ROUTES.specialOffers.meta,
				component: DASHBOARD_ROUTES.specialOffers.component,
			},
			{
				name: DASHBOARD_ROUTES.marketingCampaigns.name,
				path: DASHBOARD_ROUTES.marketingCampaigns.path,
				meta: DASHBOARD_ROUTES.marketingCampaigns.meta,
				component: DASHBOARD_ROUTES.marketingCampaigns.component,
			},
			{
				name: DASHBOARD_ROUTES.subscription.name,
				path: DASHBOARD_ROUTES.subscription.path,
				meta: DASHBOARD_ROUTES.subscription.meta,
				component: DASHBOARD_ROUTES.subscription.component,
			},
		],
	},
];

export default dashboardRoutes;
